import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  NotificationsScreenComponent
} from './screen/notifications-screen.component';
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/notifications.reducer";
import {EffectsModule} from "@ngrx/effects";
import {NotificationsEffects} from "./core/notifications.effects";
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    NotificationsScreenComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.notifications', reducer),
    EffectsModule.forFeature(
      [NotificationsEffects]
    ),
    InfiniteScrollModule,
    ReactiveFormsModule
  ],
  schemas: []
})
export class NotificationsModule {
}
